var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistOffBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1.75,
    y: 1.5,
    fill: "#777777",
    rx: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.28 12.47a.75.75 0 0 0-1.06 1.06l2.5 2.5a.75.75 0 0 0 1.083-.023l5.5-6a.75.75 0 0 0-1.106-1.014l-4.97 5.423L9.28 12.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistOffBell);
export default __webpack_public_path__ + "static/media/ChecklistOff_Bell.1334863e9e0ba53c6db2ec5aaa5a6be8.svg";
export { ForwardRef as ReactComponent };